import SharedHeader from '@/components/share/header'
import SharedFooter from '@/components/share/footer'
import SharedSidebar from '@/components/share/sidebar'
import CreateConversation from '@/graphql/chat/mutations/create-conversation.mutation'
import CreateMessage from '@/graphql/chat/mutations/create-message.mutation'
import UpdateConversation from '@/graphql/chat/mutations/update-conversation.mutation'
import axios from 'axios'
const slackUrl = 'https://hooks.slack.com/services/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'

export default {
  name: 'like',
  components: {
    SharedHeader,
    SharedFooter,
    SharedSidebar
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    api () {
      return this.$store.getters.api
    },
    env () {
      return this.$store.getters.env
    },
    avatar () {
      return this.$store.getters.avatar
    }
  },
  data () {
    return {
      sidebar_tab: '10',
      list: [],
      loading: true,
      updating: false,
      theme: {},
      job: {},
      cards: {},
      category: {},
      study: {},
      year: {},
      isModal: false,
      modalInfo: {},
      selected: '',
      view: 1,
      status: 1,
      fields: [
        {key: 'student', label: '学生情報', sortable: false, tdClass: 'title text-left align-middle'},
        {key: 'card', label: '興味あり', sortable: false, tdClass: 'align-middle'},
        {key: 'job', label: '希望職種', sortable: false, tdClass: 'align-middle text-left'},
        {key: 'study', label: '学んでいる学問', sortable: false, tdClass: 'align-middle study text-left'}
      ],
      isBusy: false,
      emptyText: {
        pending: 'スワイプカードに興味ありが届くとこちらに表示されます。スワイプカードを配信しましよう！',
        active: 'メッセージ中の学生がこちらに表示されます。興味ありからメッセージを送りましょう！',
        done: 'メッセージを終了するとこちらに表示されます。'
      },
      s_modal: {
        isOpen: false,
        item: {
          academicBackground: {},
          theme: [],
          job: [],
          category: [],
          study: [],
          screening: {},
          badge: [],
          profile: {},
          status: 0
        },
        loading: false,
        type: 1,
        index: 0,
        updating: false
      },
      scout: {
        loading: false,
        title: '興味をもっていただきありがとうございます！',
        message: 'はじめまして！株式会社＿＿の＿＿と申します！\nこの度は弊社のカードにご興味をお持ち頂きましてありがとうございます。\n＿＿さんのプロフィールを拝見しまして非常に興味を持っております。\nよろしければ一度、お気軽な感じで構いませんので、お話をしませんか？\n弊社や弊社のサービスをご紹介した上で、\n＿＿さんのやりたいことや興味のあることをお聞きできれば幸いです！\nよろしくお願い致します！',
        templateSave: false,
        selected: '',
        options: [
          {value: '', text: '選択してください'},
          {value: '1', text: '興味をもっていただきありがとうございます！'},
          {value: '2', text: 'ランチをしながらお話ししてみませんか？'}
        ],
        template: {
          1: {
            title: '興味をもっていただきありがとうございます！',
            message: 'はじめまして！株式会社＿＿の＿＿と申します！\nこの度は弊社のカードにご興味をお持ち頂きましてありがとうございます。\n＿＿さんのプロフィールを拝見しまして非常に興味を持っております。\nよろしければ一度、お気軽な感じで構いませんので、お話をしませんか？\n弊社や弊社のサービスをご紹介した上で、\n＿＿さんのやりたいことや興味のあることをお聞きできれば幸いです！\nよろしくお願い致します！'
          },
          2: {
            title: 'ランチをしながらお話ししてみませんか？',
            message: '初めまして。株式会社＿＿の＿＿と申します！\n弊社のカードに興味をもっていただいたこと、とても嬉しく思っております！\n＿＿様のプロフィールを拝見させていただき、とても魅力を感じました。\nよろしければ一度ランチでもしながらお話をしたいのですが、いかがでしょうか？\nお気軽な感じで構いませんので、よろしくお願いいたします！'
          }
        }
      },
      pagination: {
        perPage: 15,
        page_offset: 0,
        currentPage: 1,
        loading: false
      },
      cnt: {
        pending: 0,
        active: 0,
        done: 0
      },
      filter: {
        cards: [],
        study: [],
        theme: [],
        job: [],
        category: [],
        year: [],
        avatar: false,
        sex: [],
        badge: []
      }
    }
  },
  mounted () {
    this.loading = true

    if (!this.$route.query.status) {
      let query = Object.assign({}, this.$route.query)
      query.status = 'pending'
      this.$router.push({query})
    }

    switch (this.$route.query.status) {
      case 'pending':
        this.status = 1
        break
      case 'active':
        this.status = 2
        break
      case 'done':
        this.status = 3
        break
    }

    if (this.$route.query.cards) this.filter.cards = Array.isArray(this.$route.query.cards) ? this.$route.query.cards : [this.$route.query.cards]
    if (this.$route.query.study) this.filter.study = Array.isArray(this.$route.query.study) ? this.$route.query.study : [this.$route.query.study]
    if (this.$route.query.job) this.filter.job = Array.isArray(this.$route.query.job) ? this.$route.query.job : [this.$route.query.job]
    if (this.$route.query.category) this.filter.category = Array.isArray(this.$route.query.category) ? this.$route.query.category : [this.$route.query.category]
    if (this.$route.query.theme) this.filter.theme = Array.isArray(this.$route.query.theme) ? this.$route.query.theme : [this.$route.query.theme]
    if (this.$route.query.year) this.filter.year = Array.isArray(this.$route.query.year) ? this.$route.query.year : [this.$route.query.year]

    this.getTemplate()
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.pagination.loading = true

      let pathParams = {
        swipeId: 'like'
      }

      let additionalParams = {
        queryParams: {
          type: 'like',
          status: this.$route.query.status,
          page_size: this.pagination.perPage,
          page_offset: this.pagination.page_offset,
          card: this.filter.cards,
          study: this.filter.study,
          job: this.filter.job,
          category: this.filter.category,
          theme: this.filter.theme,
          year: this.filter.year
        }
      }

      this.$apig.get(this.api.SWIPE, pathParams, additionalParams, {})
        .then(response => {
          this.list = this.list.concat(response.data.students)
          if (this.pagination.currentPage === 1) this.theme = response.data.theme
          if (this.pagination.currentPage === 1) this.job = response.data.job
          if (this.pagination.currentPage === 1) this.category = response.data.category
          if (this.pagination.currentPage === 1) this.study = response.data.study
          if (this.pagination.currentPage === 1) this.year = response.data.year
          if (this.pagination.currentPage === 1) this.cards = response.data.cards
          if (this.$route.query.id) this.selected = this.$route.query.id
          this.cnt = response.data.cnt
          this.pagination.page_offset = response.data.page_offset
          this.pagination.currentPage++

          this.pagination.loading = false
          this.isBusy = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    getTemplate () {
      this.scout.options = [
        {value: '', text: '選択してください'},
        {value: '1', text: '興味をもっていただきありがとうございます！'},
        {value: '2', text: 'ランチをしながらお話ししてみませんか？'}
      ]

      let pathParams = {
        conversationId: 'template'
      }

      let additionalParams = {
        queryParams: {
          type: 'template'
        }
      }

      this.$apig.get(this.api.CONTACT, pathParams, additionalParams, {})
        .then(response => {
          for (let templateId in response.data.template) {
            this.scout.template[templateId] = response.data.template[templateId]
            if (templateId === '1' || templateId === '2') this.scout.options[Number(templateId)].text = response.data.template[templateId].title
          }

          for (let item of response.data.options) {
            if (item.value !== '1' && item.value !== '2') this.scout.options.push(item)
          }

          if (!this.scout.selected) {
            this.scout.selected = '1'
            this.scout.title = this.scout.template['1'].title
            this.scout.message = this.scout.template['1'].message
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getCover (id) {
      return `${this.env.S3}/student/avatar/${id}.png`
    },
    openModal (item) {
      this.modalInfo = item
      this.isModal = true
    },
    update () {
      this.updating = true

      let pathParams = {
        swipeId: this.modalInfo.swipeId
      }

      let additionalParams = {
        queryParams: {
          type: this.modalInfo.status === 2 ? 'undo' : this.modalInfo.status === 3 ? 'stop' : 'delete',
          planId: this.user.planId
        }
      }

      this.$apig.patch(this.$store.getters.api.SWIPE, pathParams, additionalParams, {})
        .then(response => {
          this.fetchData()
          this.updating = false
          this.isModal = false
        })
        .catch(err => {
          // 失敗のアラート
          console.log(err)
          this.updating = false
        })
    },
    selectRow (item, index, event) {
      document.getElementById('s_modal_header').scrollIntoView()
      this.s_modal.isOpen = true
      this.s_modal.item = item
      this.s_modal.index = index
      this.$emit('modalOpen')
    },
    close () {
      this.s_modal = {
        isOpen: false,
        item: {
          academicBackground: {},
          theme: [],
          job: [],
          category: [],
          study: [],
          screening: {},
          badge: [],
          profile: {},
          status: 0
        },
        loading: false,
        type: 1,
        index: 0,
        updating: false
      }
      this.$emit('modalClose')
    },
    setTemplate () {
      if (this.scout.selected) {
        this.scout.title = this.scout.template[this.scout.selected].title
        this.scout.message = this.scout.template[this.scout.selected].message
      } else {
        this.scout.title = ''
        this.scout.message = ''
      }
    },
    send () {
      this.updating = true

      let pathParams = {
        conversationId: 'new'
      }

      let additionalParams = {
        queryParams: {
          type: 'scout'
        }
      }

      let body = {
        studentId: this.s_modal.item.studentId,
        title: this.scout.title,
        message: this.scout.message,
        templateId: this.scout.selected,
        isTemplate: this.scout.templateSave
      }

      this.$apig.patch(this.api.CONTACT, pathParams, additionalParams, body)
        .then(response => {
          let conversationId = response.data.conversationId

          this.createConversation(conversationId, this.s_modal.item.studentId, this.scout.title)
            .then(() => {
              let content = this.scout.message
              this.sendMessage(conversationId, this.s_modal.item.studentId, content)
                .then(messageId => {
                  let room = {
                    id: conversationId,
                    user: {
                      id: this.user.enterpriseId,
                      name: this.user.name
                    },
                    opponent: {
                      id: this.s_modal.item.studentId,
                      name: this.s_modal.item.nickname
                    },
                    title: this.scout.title
                  }
                  let message = {
                    id: messageId,
                    content
                  }
                  this.sendSlackHook(room, message)
                  this.list.splice(this.s_modal.index, 1)
                  this.cnt.pending--
                  this.cnt.active++
                  this.s_modal.item.conversationId = conversationId
                  this.s_modal.item.status = 1
                  this.s_modal.type = 1
                  this.updating = false
                })
            })
        })
        .catch(err => {
          console.log(err)
          this.error = err.response.data
          this.isAlert = true
          window.scrollTo(0, 0)
          this.updating = false
        })
    },
    async createConversation (conversationId, opponentId, title) {
      let updatedAt = new Date()
      let id = conversationId

      await this.$apollo.mutate({
        mutation: CreateConversation,
        variables: {
          input: {
            id,
            userId: this.user.enterpriseId,
            userType: 'ENTERPRISE',
            opponentId,
            opponentType: 'STUDENT',
            updatedAt,
            title
          }
        }
      })

      await this.$apollo.mutate({
        mutation: CreateConversation,
        variables: {
          input: {
            id,
            userId: opponentId,
            userType: 'STUDENT',
            opponentId: this.user.enterpriseId,
            opponentType: 'ENTERPRISE',
            updatedAt,
            title
          }
        }
      })
    },
    async sendMessage (conversationId, studentId, content) {
      const messageResponce = await this.$apollo.mutate({
        mutation: CreateMessage,
        variables: {
          input: {
            ownerId: this.user.enterpriseId,
            opponentId: studentId,
            conversationId,
            ownerType: 'ENTERPRISE',
            opponentType: 'STUDENT',
            content,
            createdAt: new Date()
          }
        }
      })

      await this.$apollo.mutate({
        mutation: UpdateConversation,
        variables: {
          input: {
            id: conversationId,
            userId: this.user.enterpriseId,
            lastMessageId: messageResponce.data.createMessage.id,
            updatedAt: new Date()
          }
        }
      })

      await this.$apollo.mutate({
        mutation: UpdateConversation,
        variables: {
          input: {
            id: conversationId,
            userId: studentId,
            lastMessageId: messageResponce.data.createMessage.id,
            updatedAt: new Date()
          }
        }
      })

      return messageResponce.data.createMessage.id
    },
    sendSlackHook (room, message) {
      let title = `[${this.env.STAGE}][企業]ルームを作成しました`
      let color = '#1e4573'

      const body = {
        attachments: [
          {
            fallback: title,
            color: color,
            fields: [
              {
                title: title,
                value: `ルームid: ${room.id}\n` +
                       `メッセージid: ${message.id}\n` +
                       `送信者: ${room.user.name}\n` +
                       `送信者id: ${room.user.id}\n` +
                       `受信者: ${room.opponent.name}\n` +
                       `受信者id: ${room.opponent.id}\n` +
                       `タイトル: ${room.title}\n` +
                       `内容: ${message.content}`
              }
            ]
          }
        ]
      }

      axios.post(slackUrl, JSON.stringify(body), { responseType: 'text' })
    },
    selectStatus (status, value) {
      this.isBusy = true
      this.status = value
      this.pagination.page_offset = 0
      this.pagination.currentPage = 1
      this.list = []

      let query = Object.assign({}, this.$route.query)
      query.status = status
      this.$router.push({query})

      this.fetchData()
    },
    selectQuery (key, item, selectId) {
      if (!item.selected) {
        this.filter[key].push(selectId)
        let query = Object.assign({}, this.$route.query)
        query[key] = this.filter[key]
        this.$router.push({query})
      } else {
        this.filter[key].splice(this.filter[key].findIndex(id => id === selectId), 1)
        let query = Object.assign({}, this.$route.query)
        query[key] = this.filter[key]
        this.$router.push({query})
      }

      this.pagination.loading = true
      this.isBusy = true
      this.pagination.page_offset = 0
      this.pagination.currentPage = 1
      this.list = []
      this.fetchData()
    },
    clearQuery (key, selectId) {
      this.filter[key].splice(this.filter[key].findIndex(id => id === selectId), 1)
      this[key][selectId].selected = false
      let query = Object.assign({}, this.$route.query)
      query[key] = this.filter[key]
      this.$router.push({query})

      this.pagination.loading = true
      this.isBusy = true
      this.pagination.page_offset = 0
      this.pagination.currentPage = 1
      this.list = []
      this.fetchData()
    },
    updateStatus () {
      this.s_modal.updating = true

      let pathParams = {
        conversationId: this.s_modal.item.conversationId
      }

      let additionalParams = {
        queryParams: {
          type: 'message'
        }
      }

      let body = {
        status: this.s_modal.item.status === 1 ? 2 : 1
      }

      this.$apig.patch(this.api.CONTACT, pathParams, additionalParams, body)
        .then(() => {
          if (this.s_modal.item.status === 1) {
            this.cnt.active--
            this.cnt.done++
            this.s_modal.item.status = 2
          } else {
            this.cnt.done--
            this.cnt.active++
            this.s_modal.item.status = 1
          }

          this.list.splice(this.s_modal.index, 1)
          this.s_modal.updating = false
        })
        .catch(err => {
          console.log(err)
          this.s_modal.updating = false
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/like/like.js